import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Sequence extends Component {
  constructor(props) {
    super(props);
   
    this.state = {
      selected: [],
      field: this.props.field,
      versionNumber: 1
    }
  }

  componentDidMount() {
    console.log(this.state.field)
  }


  doStuff(){
    console.log("DOING STUFF-----------------------")
    console.log(this.state.field.steps)
  }

  render() {
    return (
      <button onClick={this.doStuff.bind(this)}>{this.state.field.displayName}</button>
    );
  }
}

Sequence.propTypes = {
};

export default Sequence;